/**
 * Format helper
 */
const formatters = {

  with_k : function (value) {
    if(value > 1000){
      return Math.round(value/1000) + 'k'
    }

    return value;
  },

  /**
   * Convert number to human-readable format (ex: 10 000 => 10k)
   * @param amount
   * @returns {string}
   */
  human_readable_number: function (number) {
    const is_negative = number < 0,
        nb_abs_value = Math.abs(number);

    function add_spaces(str_number){
      let int_part = str_number.split('.')[0],
          decimal_part = str_number.split('.')[1],
          i;

      for(i=int_part.length-3 ; i > 0 ; i=i-3){
        int_part = int_part.substr(0, i) + ' ' + int_part.substr(i);
      }

      // Remove decimal_part if equal to zero
      decimal_part = decimal_part && Number.parseInt(decimal_part) !== 0 ? decimal_part : null;

      return int_part + (decimal_part ? ',' + decimal_part : '');
    }

    // Millions
    if(this.round_big_number(nb_abs_value) >= 1000000){
      number = add_spaces((number / 1000000).toFixed(2));
      return is_negative ? '-' : '' + number + ' m';
    }
    // Other
    else {
      number = add_spaces(this.round_big_number(number).toFixed(0));
      return is_negative ? '-' : '' + number;
    }
  },

  /**
   * Format time to XXminXXs format
   * @param time in milliseconds
   * @returns {string}
   */
  time_mm_ss : function(time){
    let seconds, minutes, t;

    t = time / 1000;
    seconds = Number.parseInt(t % 60);
    t /= 60;
    minutes = Number.parseInt(t % 60);

    minutes = minutes === 0 ? '' : minutes + 'min';
    seconds = (minutes ? (seconds < 10 ? '0' + seconds : seconds) : seconds) + 's';

    return minutes+seconds;
  },

  /**
   * Force the sign before the number. Ex: + 3.4, - 10, ...
   * @param number
   * @returns {string}
   */
  signed_number : function (number) {
    const abs_value = Math.abs(number);
    return number > 0 ? '+ ' + abs_value : '- ' + abs_value;
  },

  /**
   * Round big number to be more readable
   * @param number
   * @returns {*}
   */
  round_big_number : function (number) {
    const abs_value = Math.abs(number);

    if(abs_value > 10000){
      number = 500 * Math.round(number/500);
    }
    else if(abs_value > 1000){
      number = 50 * Math.round(number/50);
    }
    else if(abs_value > 100){
      number = 10 * Math.round(number/10);
    }
    else {
      number = Math.round(number);
    }

    return number;
  },

  round_big_number_with_million : function (number) {
    const abs_value = Math.abs(number);

    if(abs_value > 1000000) {
      number = 100000 * Math.round(number/100000); // note that we divide by 100k
    }
    else {
      number = this.round_big_number(number);
    }

    return number;
  },

  /**
   * Round number
   * @param number
   * @param precision
   * @returns {number}
   */
  round: function (number, precision) {
    precision = precision ? Math.pow(10, precision) : 10;

    return Math.round(number*precision) / precision;
  }
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = formatters;
} else {
  window.formatters = formatters;
}
